import { VERSION } from '../version/version';
import { Injectable, PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class VersionService {
  private readonly version = `${VERSION.version}-${VERSION.timestamp}`;

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {}

  addVersion(url: string | null): string {
    if (!url) return '';

    // Xử lý URL để lấy phần path
    let processedUrl = url;

    if (isPlatformBrowser(this.platformId)) {
      // Code chỉ chạy ở browser
      try {
        if (url.startsWith('http')) {
          // Kiểm tra URL external
          if (!url.includes(window.location.host)) {
            return url;
          }
          const urlObj = new URL(url);
          processedUrl = urlObj.pathname + urlObj.search;
        }
      } catch (e) {
        console.error('Invalid URL:', url);
      }
    }

    const separator = processedUrl.includes('?') ? '&' : '?';
    return `${processedUrl}${separator}v=${this.version}`;
  }

  getVersion(): string {
    return this.version;
  }
}
